'use server'

import { apiRequest, ApiResponse } from '../request'

export interface PlanTier {
    id: number
    name: string
    resources: Record<string, string[]>
    // Keys/ids dos módulos do tier (M:N) — vem no findAll/findOne.
    modules?: { id: number; key: string }[]
    createdAt: string
    updatedAt: string
    _count?: {
        modules: number
        plans: number
    }
}

export interface CreatePlanTierData {
    name: string
    resources?: Record<string, string[]>
    moduleIds?: number[]
}

export interface UpdatePlanTierData {
    name?: string
    resources?: Record<string, string[]>
    moduleIds?: number[]
}

export async function getPlanTiers(): Promise<ApiResponse<PlanTier[]>> {
    return apiRequest<PlanTier[]>('plan-tiers', {})
}

export async function getPlanTier(
    id: number,
): Promise<ApiResponse<PlanTier>> {
    return apiRequest<PlanTier>(`plan-tiers/${id}`, {})
}

export async function createPlanTier(
    data: CreatePlanTierData,
): Promise<ApiResponse<PlanTier>> {
    return apiRequest<PlanTier>('plan-tiers', { data }, 'post')
}

export async function updatePlanTier(
    id: number,
    data: UpdatePlanTierData,
): Promise<ApiResponse<PlanTier>> {
    return apiRequest<PlanTier>(`plan-tiers/${id}`, { data }, 'patch')
}

export async function deletePlanTier(
    id: number,
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`plan-tiers/${id}`, {}, 'delete')
}
